import { useCallback } from 'react'
import axios from 'axios'

const FOUR_BYTE_API_URL = 'https://www.4byte.directory/api/v1'

export const useFourByteDirectory = () => {
    const getFunctionSignature = useCallback(async hexSignature => {
        try {
            const response = await axios.get(`${FOUR_BYTE_API_URL}/signatures/`, {
                params: {
                    hex_signature: hexSignature
                }
            })

            return response.data
        } catch (err) {
            return hexSignature
        }
    }, [])

    return {
        getFunctionSignature
    }
}
